module.exports = __webpack_public_path__ + "media/img/frontend_application/stats/icon-unsubscribed-c8a9388612e27bec10d2659a728a677e.png";